// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"d2f24081","248":"ef7a5a79","278":"e8255016","601":"6cb2f25a","702":"5afda854"}[chunkId] + ".chunk.js";
};